import type { RootState } from '../store';

export const selectActivePanel = (state: RootState) => state.assetsPanel.activePanel;
